import Button from "components/atoms/Button/Button";
import Input from "components/atoms/Input/Input";
import { VideoCall } from "../VideoCall/VideoCall";
import { FormattedMessage } from "react-intl";
import { Videocam } from "@mui/icons-material";

export type VideoCallUsernameProps = {
  className?: string;
  roomName: string;
  username: string;
  editableUsername?: boolean;
  setUsername?: (value: string) => void;
  onConfirm: () => void;
  tabletUser: string;
}

const VideoCallLanding = ({ className, roomName, username, setUsername, editableUsername = true, onConfirm, tabletUser }: VideoCallUsernameProps): JSX.Element => {
  const randomId = (Math.random() + 1).toString(36).substring(7);

  return (
    <div className={`flex flex-col md:flex-row gap-4w items-center ${className}`}>
      <VideoCall 
          className="self-center w-[85vw] md:w-[50vw] h-[50vh] " 
          username='me' 
          roomName={`${roomName}_${randomId}`} />
      <div className="flex flex-col items-center gap-4w">
        <h1 className="text-header5 self-center">
          <FormattedMessage id="videoCall.call.title" values={{ tabletOwner: tabletUser }}  />
        </h1>
        <div className="flex flex-col w-full gap-1w">
          <h2 className="text-subtitle1"><FormattedMessage id="videoCall.call.firstName" /></h2>
          <Input value={username} disabled={!editableUsername} onChange={setUsername} placeholder="Saisir votre prénom" />
        </div>
        <Button onClick={onConfirm}>
          <div className="flex justify-center items-center gap-1v">
            <Videocam />
            <FormattedMessage id="videoCall.call.join" />
          </div>
        </Button>
      </div>
    </div>
  )
}

export default VideoCallLanding;